// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"129":"735223e5","543":"aeb267e4","731":"c31f5783","789":"2da7ebab","907":"6755d38a"}[chunkId] + ".js";
};